import * as S from './Loading.style';

export { default as Loading } from './Loading';
export * from './Loading.types';
export { S };
